import * as Yup from "yup";
export const courseSectionValidation = Yup.object().shape({
  name: Yup.string().required("وارد کردن نام الزامی است"),
  url: Yup.string().required("وارد کردن آدرس الزامی است"),
});
